export default "__VITE_ASSET__D8BpHjl6__"